import { render, staticRenderFns } from "./DiscountCustomerDetails.vue?vue&type=template&id=672e30b9"
import script from "./DiscountCustomerDetails.vue?vue&type=script&lang=js"
export * from "./DiscountCustomerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports